"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Emitter = void 0;
//interface Emitter<T extends EventMap> {
//  on<K extends EventKey<T>>(eventName: K, fn: EventReceiver<T[K]>): void;
//  off<K extends EventKey<T>>(eventName: K, fn: EventReceiver<T[K]>): void;
//  emit<K extends EventKey<T>>(eventName: K, params: T[K]): void;
//}
class Emitter {
    constructor() {
        this.callbacks = {};
    }
    on(eventName, fn) {
        if (!this.callbacks[eventName]) {
            this.callbacks[eventName] = [];
        }
        this.callbacks[eventName].push(fn);
    }
    off(eventName, fn) {
        if (this.callbacks[eventName]) {
            const idx = this.callbacks[eventName].indexOf(fn);
            if (idx > -1) {
                this.callbacks[eventName].splice(idx, 1);
            }
        }
    }
    emit(eventName, params) {
        (this.callbacks[eventName] || []).forEach(handler => {
            try {
                handler(params);
            }
            catch (error) {
                console.error(`Error calling '${eventName}' event handler: ${error}`);
            }
        });
    }
}
exports.Emitter = Emitter;
//function createEmitter<T extends EventMap>(): Emitter<T> {
//  return new EventEmitter();
//}
//export class MyEmitter<T extends EventMap> implements Emitter<T> {
//  private emitter = new EventEmitter();
//  on<K extends EventKey<T>>(eventName: K, fn: EventReceiver<T[K]>) {
//    this.emitter.on(eventName, fn);
//  }
//
//  off<K extends EventKey<T>>(eventName: K, fn: EventReceiver<T[K]>) {
//    this.emitter.off(eventName, fn);
//  }
//
//  emit<K extends EventKey<T>>(eventName: K, params: T[K]) {
//    this.emitter.emit(eventName, params);
//  }
//}
//# sourceMappingURL=events.js.map